import { Icon } from '@design/components/icon/Icon';
import { config } from '@terminal/config';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import styles from './ChartError.module.scss';

export const ChartError = () => {
  const { t } = useTranslation(['earnings', 'common']);

  return (
    <div className={styles.chartErrorRoot} data-testid="chart-error">
      <Icon
        className={styles.errorIcon}
        iconName="ExclamationTriangle"
        viewBox="0 0 60 60"
        fillColor="none"
      />
      <div className={styles.title}> {t('earnings:error.title')}</div>
      <div className={styles.description}>
        <Trans
          i18nKey={'earnings:error.description'}
          components={[
            <a
              className={styles.link}
              key="key-0"
              title={t('earnings:error.linkAlt')}
              href={`mailto:${config.supportEmail}`}
            />,
          ]}
          values={{ email: config.supportEmail }}
        />
      </div>
    </div>
  );
};
